import ExperimentalLabel from 'src/components/ExperimentalLabel/ExperimentalLabel';
import animationMov from 'src/static/animations/home/intro-animation.mp4';
import animationWebm from 'src/static/animations/home/intro-animation.webm';
import poster from 'src/static/animations/home/poster.png';

import './IntroAnimation.sass';

const IntroAnimation = () => {
	const posterSrc = `${window?._env_?.HOST_URL ?? ''}${poster}`;
	return (
		<div id="intro-animation">
			<video id="intro-animation" disableRemotePlayback autoPlay muted playsInline poster={posterSrc} loop>
				<source src={animationMov} type="video/mp4;codecs=hvc1" />
				<source src={animationWebm} type="video/webm" />
			</video>
			<ExperimentalLabel />
		</div>
	);
};

export default IntroAnimation;
